"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimWidget = void 0;
const kpi_element_1 = require("client/components/kpi-header/kpi-element");
const button_1 = require("client/components/material/button");
const table_1 = require("client/components/material/table");
const table_row_1 = require("client/components/material/table/table-row");
const store_1 = require("client/modules/dashboard/store");
const store_2 = require("client/modules/orders/store");
const store_3 = require("client/modules/users/store");
const Table_1 = require("material-ui/Table");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const React = require("react");
const order_1 = require("shared/order");
const permissions_1 = require("shared/permissions");
const capitalize_string_1 = require("shared/util/capitalize-string");
const throttle_debounce_1 = require("throttle-debounce");
require("./claim-widget.less");
const columns = [
    {
        center: false,
        id: "patient.lastName",
        numeric: false,
        label: "Patient"
    },
    {
        center: true,
        id: "provider.lastName",
        numeric: false,
        label: "Provider"
    },
    {
        center: true,
        id: "order.createDate",
        numeric: false,
        label: "Appt Time"
    },
    {
        center: true,
        id: "order.status",
        numeric: false,
        label: "Status"
    },
    {
        center: true,
        id: "",
        numeric: false,
        label: "Time Remaining"
    }
];
const stats = {
    ready: 0,
    pending: 0,
    error: 0,
    done: 0,
    intended: 0
};
let ClaimWidget = class ClaimWidget extends React.Component {
    constructor() {
        super(...arguments);
        this.order = "ASC";
        this.orderBy = "order.createDate";
        this.stats = stats;
        this.moveToTop = "";
        this.clickedElement = "";
        this.loadOrders = throttle_debounce_1.debounce(200, async () => {
            const filterByIntent = this.clickedElement === kpi_element_1.KPIElementColor.Blue;
            const options = {
                clickedElement: this.clickedElement,
                count: 100,
                order: this.order,
                sort: this.orderBy,
                searchDate: filterByIntent ? "" : new Date().toDateString(),
                showCompleted: "false",
                siteId: store_3.usersStore.user.value.siteId,
                start: 0,
                type: 0,
                moveToTop: this.moveToTop
            };
            await store_2.ordersStore.loadOrders(options);
        });
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.loadOrders();
        };
        this.getStatus = (row) => {
            let statusText = "Claim Status"; // This should never show up.
            const auditUnsubmitted = row.auditStatus === order_1.AuditStatus.Unsubmitted;
            const auditPending = row.auditStatus === order_1.AuditStatus.Pending;
            const isError = row.status === order_1.OrderStatus.Error;
            const noneApprovedMsg = row.message.toLowerCase() === "no claims approved";
            const clinicErrorMessage = isError && noneApprovedMsg ? "None Approved" : "Out of Network";
            const isNotApproved = clinicErrorMessage === "None Approved";
            const isDev = store_3.usersStore.user.value.groupId === permissions_1.GROUPS.DEV;
            switch (row.status) {
                case order_1.OrderStatus.Ready:
                    statusText = auditUnsubmitted
                        ? "Ready for Provider Review"
                        : auditPending
                            ? "Approved to Dispense"
                            : "Ready To Dispense";
                    break;
                case order_1.OrderStatus.Pending:
                    statusText = "Pending Adjudication";
                    break;
                case order_1.OrderStatus.Intended:
                    statusText = "Intend to Dispense";
                    break;
                case order_1.OrderStatus.Progress:
                case order_1.OrderStatus.Executing:
                    statusText = "In Progress";
                    break;
                case order_1.OrderStatus.Reversed:
                    statusText = "Canceled";
                    break;
                case order_1.OrderStatus.Error:
                    statusText = store_3.usersStore.permissions.ReadErrors
                        ? row.refill
                            ? "Refill Error"
                            : isNotApproved
                                ? "Ready to Cancel"
                                : "Error"
                        : clinicErrorMessage;
                    break;
                case order_1.OrderStatus.ReverseError:
                    statusText = isDev ? "Failed to Reverse" : "Pending Reversal";
                    break;
                case order_1.OrderStatus.Refill:
                    statusText = "Refill Due";
                    break;
                case order_1.OrderStatus.Refilled:
                    statusText = "Refilled";
                    break;
                case order_1.OrderStatus.Reversing:
                    statusText = "Reversing";
                    break;
                case order_1.OrderStatus.Done:
                    statusText = "Dispensed";
                    break;
                default:
                    statusText = "Dispensed";
                    break;
            }
            return statusText;
        };
        this.renderTableRow = (row, index) => {
            const now = moment();
            const appt = moment(row.createDate);
            const diff = appt.diff(now);
            const status = row.status;
            const duration = moment.duration(appt.diff(now));
            const days = appt.diff(now, "days");
            let timeRemaining = "";
            if (diff > 0) {
                if (days > 0) {
                    timeRemaining = `${timeRemaining} ${days}d`;
                }
                timeRemaining = `${timeRemaining} ${duration
                    .hours()
                    .toString()
                    .padStart(2, "0")}:${duration
                    .minutes()
                    .toString()
                    .padStart(2, "0")}:${duration
                    .seconds()
                    .toString()
                    .padStart(2, "0")}`;
            }
            else {
                timeRemaining = "Over Due";
            }
            const time = moment.tz(row.createDate, row.site.timezone);
            const auditUnsubmitted = row.auditStatus === order_1.AuditStatus.Unsubmitted;
            const auditPending = row.auditStatus === order_1.AuditStatus.Pending;
            const isError = row.status === order_1.OrderStatus.Error;
            const noneApprovedMsg = row.message.toLowerCase() === "no claims approved";
            const clinicErrorMessage = isError && noneApprovedMsg ? "None Approved" : "Out of Network";
            const isNotApproved = clinicErrorMessage === "None Approved";
            const isDev = store_3.usersStore.user.value.groupId === permissions_1.GROUPS.DEV;
            let statusText = "Claim Status"; // This should never show up.
            switch (row.status) {
                case order_1.OrderStatus.Ready:
                    statusText = auditUnsubmitted
                        ? "Ready for Provider Review"
                        : auditPending
                            ? "Approved to Dispense"
                            : "Ready To Dispense";
                    break;
                case order_1.OrderStatus.Pending:
                    statusText = "Pending Adjudication";
                    break;
                case order_1.OrderStatus.Intended:
                    statusText = "Intend to Dispense";
                    break;
                case order_1.OrderStatus.Progress:
                case order_1.OrderStatus.Executing:
                    statusText = "In Progress";
                    break;
                case order_1.OrderStatus.Reversed:
                    statusText = "Canceled";
                    break;
                case order_1.OrderStatus.Error:
                    statusText = store_3.usersStore.permissions.ReadErrors
                        ? row.refill
                            ? "Refill Error"
                            : isNotApproved
                                ? "Ready to Cancel"
                                : "Error"
                        : clinicErrorMessage;
                    break;
                case order_1.OrderStatus.ReverseError:
                    statusText = isDev ? "Failed to Reverse" : "Pending Reversal";
                    break;
                case order_1.OrderStatus.Refill:
                    statusText = "Refill Due";
                    break;
                case order_1.OrderStatus.Refilled:
                    statusText = "Refilled";
                    break;
                case order_1.OrderStatus.Reversing:
                    statusText = "Reversing";
                    break;
                case order_1.OrderStatus.Done:
                    statusText = "Dispensed";
                    break;
                default:
                    statusText = "Dispensed";
                    break;
            }
            // commenting this out to mimic Nick's fix of merge request !630
            // if (statusText === "None Approved") row.status = OrderStatus.Reversed;
            const readFailures = store_3.usersStore.permissions.ReadFailures;
            const readErrors = store_3.usersStore.permissions.ReadErrors;
            const thisOrderIsAnError = row.status === order_1.OrderStatus.Error ||
                row.status === order_1.OrderStatus.ReverseError;
            if (thisOrderIsAnError) {
                /** If the user shouldn't see any red claims, or if they don't have permission
                 * to view failure-level claims and this claim was failure-level, don't render.
                 */
                if (!readErrors ||
                    (!readFailures &&
                        (statusText === "Error" ||
                            statusText === "Failed to Reverse" ||
                            statusText === "Pending Reversal"))) {
                    return null;
                }
            }
            const patientName = `${row.patient.lastName}, ${row.patient.firstName}`;
            const providerName = `${row.provider.lastName}, ${row.provider.firstName}`;
            return (React.createElement(table_row_1.MaterialTableRow, { key: index, to: `../../claims/${row.id}` },
                React.createElement(Table_1.TableCell, null, capitalize_string_1.capitalizeString(patientName)),
                React.createElement(Table_1.TableCell, null, capitalize_string_1.capitalizeString(providerName)),
                React.createElement(Table_1.TableCell, null, row.createDate &&
                    moment(row.createDate).format("MM/DD/YYYY hh:mm A")),
                React.createElement(Table_1.TableCell, { "data-tip": row.message }, React.createElement("div", { className: "orders-list__row" },
                    React.createElement("div", { className: `orders-list__status orders-list__status--${row.status}` }),
                    React.createElement("div", { className: "orders-list__status-text" }, this.getStatus(row)))),
                React.createElement(Table_1.TableCell, null, (row.status !== order_1.OrderStatus.Done &&
                    row.status !== order_1.OrderStatus.Refilled &&
                    row.status !== order_1.OrderStatus.Reversed &&
                    timeRemaining) ||
                    "")));
        };
        this.renderTable = () => {
            let { orders: { value: orders = [] } } = store_2.ordersStore;
            if (!store_3.usersStore.permissions.ReadErrors) {
                orders = orders.filter(order => !(order.status === order_1.OrderStatus.Error ||
                    order.status === order_1.OrderStatus.ReverseError));
            }
            if (store_3.usersStore.userProvider &&
                store_3.usersStore.userProvider.value &&
                store_3.usersStore.userProvider.value.userId === store_3.usersStore.user.value.id &&
                store_3.usersStore.user.value.siteUser &&
                !store_3.usersStore.user.value.siteAdmin) {
                orders = orders.filter(order => order.provider.userId === store_3.usersStore.user.value.id);
            }
            return (React.createElement("div", { className: "orders__list" }, store_2.ordersStore.orders.value && (React.createElement(table_1.MaterialTable, { clickable: true, noMargin: true, columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: orders, renderRow: this.renderTableRow }))));
        };
        this.handleTableFilter = (status) => (event) => {
            event.preventDefault();
            event.stopPropagation();
            switch (status) {
                case order_1.OrderStatus.Ready:
                    this.clickedElement = kpi_element_1.KPIElementColor.Green;
                    break;
                case order_1.OrderStatus.Pending:
                    this.clickedElement = kpi_element_1.KPIElementColor.Yellow;
                    break;
                case order_1.OrderStatus.Intended:
                    this.clickedElement = kpi_element_1.KPIElementColor.Blue;
                    break;
                case order_1.OrderStatus.Done:
                    this.clickedElement = kpi_element_1.KPIElementColor.LightGreen;
                    break;
                default:
                    break;
            }
            // if (this.moveToTop === status) {
            //   this.moveToTop = "";
            // } else {
            //   this.moveToTop = status;
            // }
            this.loadOrders();
        };
        this.renderStats = () => (React.createElement("div", { className: "orders__stats" },
            React.createElement("div", { className: "orders__stats--click", onClick: this.handleTableFilter(order_1.OrderStatus.Ready) },
                React.createElement("div", { className: "orders-list__status orders-list__status--3ready" }),
                " ",
                React.createElement("span", { className: "orders-list__status" +
                        (this.moveToTop === "3ready" ? "--label-selected" : "--label") }, "Ready:"),
                " ",
                this.stats.ready),
            React.createElement("div", { className: "orders__stats--click", onClick: this.handleTableFilter(order_1.OrderStatus.Pending) },
                React.createElement("div", { className: "orders-list__status orders-list__status--4pending" }),
                " ",
                React.createElement("span", { className: "orders-list__status" +
                        (this.moveToTop === "4pending" ? "--label-selected" : "--label") }, "Pending:"),
                " ",
                this.stats.pending),
            React.createElement("div", { className: "orders__stats--click", onClick: this.handleTableFilter(order_1.OrderStatus.Done) },
                React.createElement("div", { className: "orders-list__status orders-list__status--6done" }),
                " ",
                React.createElement("span", { className: "orders-list__status--label" }, "Completed:"),
                " ",
                this.stats.done)));
        /**
         * Returns the count for each claim status from the database.
         */
        this.getClaimData = async () => {
            const siteId = store_3.usersStore.user.value.siteId;
            const statistics = await store_1.dashboardStore.getClaimStatistics(siteId);
            // Lines below have defaults of 0 or else NaN or Undefined may potentially return.
            this.stats.ready = statistics[order_1.OrderStatus.Ready] || 0;
            this.stats.done = statistics[order_1.OrderStatus.Done] || 0;
            this.stats.intended = statistics[order_1.OrderStatus.Intended] || 0;
            this.stats.error =
                (statistics[order_1.OrderStatus.Error] || 0) +
                    (statistics[order_1.OrderStatus.ReverseError] || 0);
            this.stats.pending =
                (statistics[order_1.OrderStatus.Pending] || 0) +
                    (statistics[order_1.OrderStatus.Executing] || 0) +
                    (statistics[order_1.OrderStatus.Refill] || 0);
            await this.filterCount();
        };
        this.filterCount = async () => {
            let { orders: { value: orders = [] } } = store_2.ordersStore;
            let rawCount = this.stats.error;
            let rawCountPending = this.stats.pending;
            let rawCountReady = this.stats.ready;
            if (!store_3.usersStore.permissions.ReadErrors) {
                orders = orders.filter(order => !(order.status === order_1.OrderStatus.Error ||
                    order.status === order_1.OrderStatus.ReverseError));
            }
            const isUserProvider = store_3.usersStore.userProvider &&
                store_3.usersStore.userProvider.value &&
                store_3.usersStore.userProvider.value.userId === store_3.usersStore.user.value.id &&
                store_3.usersStore.user.value.siteUser &&
                !store_3.usersStore.user.value.siteAdmin;
            for (const row of orders) {
                const auditUnsubmitted = row.auditStatus === order_1.AuditStatus.Unsubmitted;
                const auditPending = row.auditStatus === order_1.AuditStatus.Pending;
                const isError = row.status === order_1.OrderStatus.Error;
                const noneApprovedMsg = row.message.toLowerCase() === "no claims approved";
                const clinicErrorMessage = isError && noneApprovedMsg ? "None Approved" : "Out of Network";
                const isNotApproved = clinicErrorMessage === "None Approved";
                const isDev = store_3.usersStore.user.value.groupId === permissions_1.GROUPS.DEV;
                let statusText = "Claim Status"; // This should never show up.
                switch (row.status) {
                    case order_1.OrderStatus.Ready:
                        statusText = auditUnsubmitted
                            ? "Ready for Provider Review"
                            : auditPending
                                ? "Approved to Dispense"
                                : "Ready To Dispense";
                        break;
                    case order_1.OrderStatus.Pending:
                        statusText = "Pending Adjudication";
                        break;
                    case order_1.OrderStatus.Intended:
                        statusText = "Intend to Dispense";
                        break;
                    case order_1.OrderStatus.Progress:
                    case order_1.OrderStatus.Executing:
                        statusText = "In Progress";
                        break;
                    case order_1.OrderStatus.Reversing:
                        statusText = "Canceling";
                        break;
                    case order_1.OrderStatus.Reversed:
                        statusText = "Canceled";
                        break;
                    case order_1.OrderStatus.Error:
                        statusText = store_3.usersStore.permissions.ReadErrors
                            ? isNotApproved
                                ? "Ready to Cancel"
                                : "Error"
                            : clinicErrorMessage;
                        break;
                    case order_1.OrderStatus.ReverseError:
                        statusText = isDev ? "Failed to Reverse" : "Pending Reversal";
                        break;
                    case order_1.OrderStatus.Refill:
                        statusText = "Refill Due";
                        break;
                    default:
                        statusText = "Dispensed";
                        break;
                }
                if (statusText === "None Approved")
                    row.status = order_1.OrderStatus.Reversed;
                const readFailures = store_3.usersStore.permissions.ReadFailures;
                if (isUserProvider) {
                    if (row.provider.userId !== store_3.usersStore.user.value.id) {
                        if (row.status === order_1.OrderStatus.Ready) {
                            rawCountReady--;
                        }
                        if (readFailures &&
                            (statusText === "Error" ||
                                statusText === "Failed to Reverse" ||
                                statusText === "Pending Reversal")) {
                            rawCount--;
                        }
                        if (statusText === "Pending Adjudication" ||
                            statusText === "In Progress") {
                            rawCountPending--;
                        }
                    }
                }
            }
            this.stats.error = rawCount;
            this.stats.pending = rawCountPending;
            this.stats.ready = rawCountReady;
        };
    }
    async componentDidMount() {
        // await this.loadOrders();
        const filterByIntent = this.clickedElement === kpi_element_1.KPIElementColor.Blue;
        const options = {
            clickedElement: this.clickedElement,
            count: 100,
            order: this.order,
            sort: this.orderBy,
            searchDate: filterByIntent ? "" : new Date().toDateString(),
            showCompleted: "false",
            siteId: store_3.usersStore.user.value.siteId,
            start: 0,
            type: 0,
            moveToTop: this.moveToTop
        };
        await store_2.ordersStore.loadOrders(options);
        await this.getClaimData();
    }
    render() {
        return (React.createElement("div", { className: "claims-widget widget" },
            React.createElement("header", { className: "button_actions" },
                React.createElement(button_1.MaterialButton, { secondary: true, to: "/claims/queue" }, "Queued Schedules")),
            store_3.usersStore.permissions.ReadClaims ? (React.createElement(React.Fragment, null,
                this.renderStats(),
                React.createElement("div", null, store_2.ordersStore.orders.value && this.renderTable()))) : (store_3.usersStore.showLock())));
    }
};
__decorate([
    mobx_1.observable
], ClaimWidget.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], ClaimWidget.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], ClaimWidget.prototype, "stats", void 0);
__decorate([
    mobx_1.observable
], ClaimWidget.prototype, "moveToTop", void 0);
__decorate([
    mobx_1.observable
], ClaimWidget.prototype, "clickedElement", void 0);
ClaimWidget = __decorate([
    mobx_react_1.observer
], ClaimWidget);
exports.ClaimWidget = ClaimWidget;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/modules/widget-grid/components/claim-widget/claim-widget.tsx
// module id = 3343
// module chunks = 0